module.exports = __webpack_public_path__ + "static/media/tie_green.8148aa64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tie_green.png
// module id = 129
// module chunks = 0